import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { WalkaroundQuestion } from '../models/walkaround-question.model';

@Injectable({
  providedIn: 'root'
})
export class WalkaroundQuestionValidatorService extends ValidatorService {
  isValid(data: WalkaroundQuestion) {
    this.errors = [];

    if(!this.isSupplied(data.checkInformation)) {
      this.errors.push('checkInformation');
    }

    if(!this.isDropdownSupplied(data.severity)) {
      this.errors.push('severity');
    }

    if(!this.isDropdownSupplied(data.vehicleCheckAreaId)) {
      this.errors.push('vehicleCheckAreaId');
    }

    return this.errors.length === 0;
  }
}
